import React,{useState,useRef} from "react";
import "./style.css";
import {useNavigate} from "react-router-dom";
import {Modal, Button} from "react-bootstrap"
import {UrlBaseServer} from "../../../Services/storageServer";
import {useAuth} from "../../../Services/auth";
import {useQuery} from "react-query";
import api from "../../../Services/api"
import visaCard from "./../../../Assets/visaLogo.png"

import data from "bootstrap/js/src/dom/data";
const Index = ({item}) => {
    const navigate = useNavigate();

    const {user} = useAuth()
    // const { isLoading,
    //     isError,
    //     error,
    //     data:dataBlogs,
    //     isFetching,
    //     isPreviousData, } = useQuery(['repoBlogs'], ()=> api.getBlogs(),{ keepPreviousData : true }
    // )
    function getDate(d){
        const maDate = new Date(d)

        return maDate.toLocaleDateString("fr")
    }
    return (
        <div className="container mt-5 FeedBackBox">
            <div className="row w-100">
                <div className="whiteContainer">
                    <div style={{color:"gray"}}>Le {getDate(item?.createdAt)}</div>
                    <div dangerouslySetInnerHTML={{ __html: item?.article }} >

                    </div>
                </div>
            </div>
        </div>
  );
};
export default Index;
